"use client";

import React from "react";

import { QuoteIcon } from "@/components/icons/QuoteIcon";
import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";

export type QuoteSlider2Item = {
  quote: string;
  image: string;
  name: string;
  title: string;
};

type QuoteSlider2CardProps = {
  item: QuoteSlider2Item;
};

export default function QuoteSlider2Card({ item }: QuoteSlider2CardProps) {
  return (
    <div className="relative flex h-full flex-col items-center rounded-lg bg-nova-base-solid-10 px-4 py-8 md:px-6 md:py-6">
      <QuoteIcon className="absolute left-8 top-[26px] z-[1] h-4 w-[23px] text-nova-brand-primary-80 md:left-10 md:top-4 md:w-[29px]" />
      <div className="w-full flex-1 rounded-lg bg-nova-base-white p-8 xl:px-10 xl:py-9">
        <TextElementNova element="p" text={item.quote} className="Body-20-Dia-Normal italic" />
      </div>
      <div className="mt-6 flex w-full items-center justify-center md:mt-9 md:min-h-[100px]">
        <Picture
          src={item.image}
          alt=""
          className="h-16 w-16 object-contain md:h-[72px] md:w-[72px]"
          width={72}
          height={72}
          loading="lazy"
        />
        <div className="ml-4 flex flex-col items-start md:ml-6">
          <TextElementNova element="h4" text={item.name} className="Body-30-Dia-Strong" />
          <TextElementNova element="p" text={item.title} className="Body-20-Dia-Normal" />
        </div>
      </div>
    </div>
  );
}
